import React, { useState, useEffect } from 'react';

const TypewriterText = ({ text, speed = 5, containerRef }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (index < text.length) {
            const interval = setInterval(() => {
                setDisplayedText((prev) => prev + text[index]);
                setIndex((prev) => prev + 1);
            }, speed);

            return () => clearInterval(interval);
        }
    }, [index, text, speed]);

    useEffect(() => {
        if (containerRef?.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [displayedText, containerRef]);

    return <span className='text-lg font-bold text-white'>{displayedText}</span>;
};

export default TypewriterText;